import { createSelector } from 'reselect';
import get from 'lodash/get';

import { initialState, key } from './reducer';
import { createSelectFieldOptions, updateMediaStructure } from '../../utils/common';

export const selectEditImagesDomain = state => state[key] || initialState;

const selectImages = () =>
  createSelector(selectEditImagesDomain, subState => {
    const images = get(subState, `${initialState.images.listName}.data`, []);
    return { ...get(subState, initialState.images.listName, {}), data: updateMediaStructure(images) };
  });

const selectMediaAttrTypesOptions = () =>
  createSelector(selectEditImagesDomain, subState =>
    createSelectFieldOptions(get(subState, `${initialState.attributeTypes.listName}.data`, {}), 'id', 'name'),
  );

const selectImageFormatsNames = () =>
  createSelector(selectEditImagesDomain, subState =>
    get(subState, `${initialState.imageFormats.listName}.data`, [])?.map(format => format?.slug),
  );

const selectUpdatingImageName = () =>
  createSelector(selectEditImagesDomain, subState => get(subState, 'updatingEntityName'));

const selectImageProductions = () =>
  createSelector(selectEditImagesDomain, subState => get(subState, initialState.productions.listName));

export {
  selectImages,
  selectMediaAttrTypesOptions,
  selectImageFormatsNames,
  selectUpdatingImageName,
  selectImageProductions,
};
